/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { get, isEmpty } from "lodash";
import { Col, Row } from "reactstrap";
import { getEmployee } from "../../../apis/employee/employee";
import { ColCard } from "../../../components/ContentLayout";
import { dateToViewFormat } from "../../../utils/date";
import Icon from "../../../components/Icon";
// import DocumentIcon from "../../../assets/images/icon/document-icon.svg";
import NoData from "../../../components/NoData/NoData";
import Badge from "../../../components/Badge";
// import Button from "../../../components/Button";
import { getContractsList } from "../../../apis/contract";
import { CONTRACT_TYPE } from "../../../constants/CONTRACT";
import { contractDetail } from "../../../utils/contract";
import SignCanvasModal from "./SignCanvasModal";
import ContractIcon from "../../../assets/images/icon/contract/contract-doc-icon.svg";


const UserContract = ({ user }) => {
  const _isMounted = useRef(true);
  const [, setSignature] = useState({});
  const [contractList, setContractList] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user) {
      submit();
    }

    return () => {
      _isMounted.current = false;
    };
  }, [user]);

  const submit = () => {
    const targetEmployeeIdx = user.idx || user.employeeIdx;
    getEmployee(targetEmployeeIdx).then((res) => {
      if (_isMounted) {
        setSignature(get(res, 'signature'));
      }
    });

    getContractsList({ targetEmployeeIdx: [targetEmployeeIdx] }).then(res => {
      if (_isMounted) {
        setContractList(res.data.contract.contracts?.reverse());
      }
    });
  };

  const handleOnClick = (contract) => {
    contractDetail(contract, { submit });
  };

  // const handleAddSign = () => {
  //   setOpen(true)
  // }

  return (
    <>
      <div className="user-contract-page">
        <Row>
          {/* <Col sm="4">
            <ColCard className="user-sign-container">
              <p className="user-sign-title">나의 서명</p>
              {!isEmpty(signature) && signature.img ? (
                <>
                  <div className="user-sign-wrap">
                    <img src={signature.img} alt="user-sign" />
                  </div>
                  <div className="user-sign-description-wrap">
                    <p className="sign-created-date">
                      생성 {dateToFormat(signature.createdTime)}
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <Button className="add-sign-button" size="sm" color="gray-line" label="서명등록" onClick={handleAddSign} />
                  <div className="empty-sign">
                    <Icon src={DocumentIcon} className="empty-sign-icon" />
                    <p className="empty-description">서명을 등록해주세요</p>
                  </div>
                </>
              )}
            </ColCard>
          </Col> */}
          <Col sm="12">
            {!isEmpty(contractList) ? (
              contractList.map((contract, idx) => {
                const contractInfo = CONTRACT_TYPE.find((c) => c.type === contract.type);
                const start = get(contract, 'startTime');
                const end = get(contract, 'endTime');
                return (
                  <ColCard key={idx} className="contranct-wrap" onClick={() => handleOnClick(contract)}>
                    <Icon src={get(contractInfo, 'icon', ContractIcon)} className="contract-icon" />
                    <label className="contract-title">
                      {get(contractInfo, 'label', contract?.title || '')}&nbsp;
                      {(start || end) && <>
                        ({start ? dateToViewFormat(start) : ''} ~ {end ? dateToViewFormat(end) : ''})
                      </>}
                    </label>
                    {/* <label className="contract-title">{get(contractInfo, '')}</label> */}
                    <div className="contract-sign-status-wrap">
                      <Badge
                        size="lg"
                        label={
                          contract.isSigned ? "서명완료" : "서명 대기중"
                        }
                        color={contract.isSigned ? "secondary" : "success"}
                      />
                    </div>
                  </ColCard>
                );
              })
            ) : (
              <NoData text="등록된 계약서가 없습니다." />
            )}
          </Col>
        </Row>
      </div>
      <SignCanvasModal
        open={open}
        setOpen={setOpen}
        submit={submit}
      />
    </>
  );
};

export default UserContract;
